let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eHInC")).then(() => parcelRequire('iEc3v'));